import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-application-icons',
  templateUrl: './mobile-application-icons.component.html',
  styleUrls: ['./mobile-application-icons.component.css']
})
export class MobileApplicationIconsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/mobile-application-dev/mobile-application-icons/mobile-application-icons.component.ts